import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "remove-duplicates",
  "name": "Remove Duplicates",
  "category": "data",
  "description": "Remove duplicate items based on specified fields",
  "icon": "Copy",
  "color": "cyan",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Remove Duplicates",
    "color": "#06b6d4"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "duplicate",
    "unique",
    "distinct",
    "dedupe"
  ],
  "comingSoon": false
};

export default definition;
